import { FC } from 'react';
import { Icon, type IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, useTooltip } from '@frontend/design-system';
import { useGeneratedLink } from '../../../../../hooks/useGeneratedLink';
import { useSendFormsStore } from '../../../../../providers/store';
import { DeliveryMethod } from '../../../../../types';
import { kioskMessageContainerStyle, kioskMessageButtonStyle, iconStyle } from './delivery-option.styles';

interface DeliveryOptionProps {
  icon: IconName;
  displayName: string;
  deliveryMethod: DeliveryMethod;
  onClick?: () => void;
  show?: boolean;
  trackingId?: string;
  disabled?: boolean;
  hoverLabel?: string;
}

const DeliveryOption: FC<DeliveryOptionProps> = ({
  icon,
  displayName,
  deliveryMethod,
  onClick,
  show = true,
  trackingId,
  disabled,
  hoverLabel,
}) => {
  const { setSelectedDeliveryMethod, solicitedLink } = useSendFormsStore([
    'setSelectedDeliveryMethod',
    'solicitedLink',
  ]);
  const { generateLink } = useGeneratedLink();

  async function clickHandler() {
    const shouldGenerateLink = !solicitedLink || deliveryMethod === 'kiosk';

    let success = true;

    if (shouldGenerateLink) {
      const result = await generateLink(deliveryMethod);
      success = result.success;
    }

    if (success) {
      onClick?.();
      setSelectedDeliveryMethod(deliveryMethod);
    }
  }

  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  return (
    <div css={kioskMessageContainerStyle}>
      <NakedButton
        css={kioskMessageButtonStyle}
        onClick={show ? clickHandler : undefined}
        trackingId={trackingId}
        style={show ? {} : { color: theme.colors.neutral30 }}
        {...(hoverLabel ? triggerProps : {})}
        disabled={disabled}
      >
        <Icon name={icon} css={iconStyle} />
        <div>{displayName}</div>
      </NakedButton>
      {!!hoverLabel && <Tooltip {...tooltipProps}>{hoverLabel}</Tooltip>}
    </div>
  );
};

export default DeliveryOption;
